import type { StateCreator } from 'zustand';

import type { StateSlices } from '..';

export type ResetSlice = {
  resetAllSlices: (resetUserState?: boolean) => void;
};

export const createResetSlice: StateCreator<StateSlices, [], [], ResetSlice> = (
  _set,
  get
) => ({
  resetAllSlices(resetUserState) {
    get().resetFilterSelectionSlice();
    get().resetSessionSlice();
    get().resetWorkflowStateSelectionSlice();
    get().resetTableRowSelectionSlice();
    get().resetTableGroupExpansionsSlice();
    get().resetDocumentSigningSlice();
    get().closeAllPageSidebars();

    if (resetUserState) {
      get().resetUiSlice();
    }
  },
});
